import css from '@styled-system/css';
import { ThemeStyles, IconWrapper } from '@honda-canada/design-system-react';
import styled from 'styled-components';

const themeStyles = new ThemeStyles();

const baseArrowStyles = {
  boxShadow: '0px 0px 4px 0px #00000040',
  zIndex: 1,
  position: 'absolute',
  // 22px is half of the height of the carousel arrow
  // 49% gotten from the ratio 179px to 183px from design
  bottom: 'calc(49% - 22px)',
  '&:focus': {
    border: 'transparent',
  },
};
export const StyledIconWrapper = styled(IconWrapper)(({ theme }) =>
  css({
    boxSizing: 'border-box',
    '&:focus': {
      border: 'transparent',
    },
    ...theme?.focused?.button(theme),
  }),
);

themeStyles.addBaseStyles('CarouselContainer')(({ carouselStyles }) =>
  css({
    position: 'relative',
    mx: ['-20px', '-20px', 'zero'],
    ...carouselStyles,
  }),
);

themeStyles.addBaseStyles('PrevIconWrapper')(({ theme }) =>
  css({
    ...baseArrowStyles,
    left: '10px',
    ml: ['6px', '6px', 'zero'],
    '&:focus-visible': {
      outline: `solid 3px ${theme.colors.aodaFocused}`,
      outlineOffset: '-4px',
    },
  }),
);

themeStyles.addBaseStyles('NextIconWrapper')(({ theme }) =>
  css({
    ...baseArrowStyles,
    right: '10px',
    mr: ['10px', '10px', 'zero'],
    '&:focus-visible': {
      outline: `solid 3px ${theme.colors.aodaFocused}`,
      outlineOffset: '-3px',
    },
  }),
);

export default themeStyles;
